import { Attr, BelongsTo, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';
import Facility from './facility';

@Model()
export default class SsmParameter extends ApplicationRecord {
  static jsonapiType = 'ssm_parameters';
  
  @Attr() name: string;
  @Attr() parameterType: string;
  @Attr() value: string;
  @Attr() description: string;
  @Attr() kmsKeyId: string;
  @Attr() lastAwsModifiedAt: string;
  @Attr() lastSyncedAt: string;
  @Attr() createdAt: string;
  @Attr() updatedAt: string;
  @Attr() discardedAt: string;

  @BelongsTo() facility: Facility;

  isSecureString() {
    return this.parameterType === 'SecureString';
  }

  isString() {
    return this.parameterType === 'String';
  }

  isStringList() {
    return this.parameterType === 'StringList';
  }

  hasValue() {
    return this.value && this.value.length > 0;
  }
}